/**
 * Index template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
// import Swiper JS
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Home';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.log(`${NAME} > loaded`);


  const header = document.getElementById('theme-header');
  let ticking = false;
  document.addEventListener("scroll", (event) => {
    const lastKnownScrollPosition = window.scrollY;
  
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (lastKnownScrollPosition > 300) {
          header.dataset.down = true;
        } else {
          header.dataset.down = false;
        }
        ticking = false;
      });
  
      ticking = true;
    }
  });
}

const imageSwiper = new Swiper('#hero-slider-images', {
  // Optional parameters
  // direction: 'vertical',
  loop: true,
  speed: 1500,
  delay: 500,
  allowTouchMove: false,
  effect: 'fade',
  parallax: false,
  // // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination',
  // },

  // // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },

  // // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

const detailSwiper = new Swiper('#hero-slider-details', {
  loop: true,
  speed: 1000,
  effect: 'fade',
  pagination: {
    el: '.swiper-pagination',
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});

const titleSwiper = new Swiper('#hero-slider-titles', {
  loop: true,
  speed: 1000,
  effect: 'fade',
  allowTouchMove: false,
});


detailSwiper.on('slideChange', function (r) {
  imageSwiper.slideNext();
  titleSwiper.slideNext();
});
// imageSwiper.on('slideChange', function (r) {
//   detailSwiper.slideNext();
//   titleSwiper.slideNext();
// });


// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
